import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
interface ManualCardProps {
  emoji: string;
  title: string;
  description: string;
  index: number;
}
function ManualCard({
  emoji,
  title,
  description,
  index
}: ManualCardProps) {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-50px'
  });
  return <motion.div ref={ref} className="p-6 sm:p-8 rounded-2xl bg-white border border-rose-100 shadow-lg hover:shadow-xl transition-shadow duration-300" initial={{
    opacity: 0,
    y: 30
  }} animate={isInView ? {
    opacity: 1,
    y: 0
  } : {}} transition={{
    duration: 0.5,
    delay: index * 0.1
  }} data-id="element-152">
      <div className="w-14 h-14 bg-rose-100 rounded-2xl flex items-center justify-center text-3xl mb-4" data-id="element-153">
        {emoji}
      </div>
      <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-154">{title}</h3>
      <p className="text-slate-600 text-sm leading-relaxed" data-id="element-155">{description}</p>
    </motion.div>;
}
export function ManualSection() {
  const features = [{
    emoji: '🎨',
    title: 'Materiales y Papeles',
    description: 'Qué papel usar para cada tipo de imprimible. Gramajes, acabados y proveedores recomendados.'
  }, {
    emoji: '🖨️',
    title: 'Guía de Impresión',
    description: 'Configuración de impresora, resolución y colores para resultados profesionales en casa.'
  }, {
    emoji: '✂️',
    title: 'Armado Paso a Paso',
    description: 'Instrucciones claras para montar flores, números 3D, banderines y todas las piezas del kit.'
  }, {
    emoji: '💡',
    title: 'Tips para Vender Más',
    description: 'Cómo presentar tus productos, fotografiarlos y destacarte en Etsy y redes sociales.'
  }];
  const headerRef = useRef(null);
  const isHeaderInView = useInView(headerRef, {
    once: true
  });
  return <section className="w-full bg-pink-50 py-20 sm:py-28" data-id="element-156">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-157">
        {/* Header */}
        <motion.div ref={headerRef} className="text-center mb-16" initial={{
        opacity: 0,
        y: 30
      }} animate={isHeaderInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} data-id="element-158">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-slate-900 mb-4" data-id="element-159">
            📖 Manual de Uso
          </h2>
          <p className="text-xl sm:text-2xl font-bold text-rose-500" data-id="element-160">
            Todo lo que Necesitas Saber para Empezar
          </p>
        </motion.div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-161">
          {features.map((feature, index) => <ManualCard key={feature.title} emoji={feature.emoji} title={feature.title} description={feature.description} index={index} data-id="element-162" />)}
        </div>
      </div>
    </section>;
}